import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Footer from '../components/Footer';
import { motion } from 'framer-motion'; // Import Framer Motion for animations
import '../styles/quote.css'; // Ensure styling is linked

const RequestQuote = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        details: ''
    });
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        emailjs.send(
            'service_bukwybe', 
            'template_z979hp8', 
            {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                service: formData.service,
                details: formData.details
            },
            'bNikn_83ci9KexsYW'
        )
        .then((response) => {
            console.log('Email sent successfully:', response);
            setLoading(false);
            setSubmitted(true);
            setFormData({ name: '', email: '', phone: '', service: '', details: '' });
        })
        .catch((error) => {
            console.error('Error sending email:', error);
            setError('Something went wrong. Please try again.');
            setLoading(false);
        });
    };

    return (
      <motion.div 
        className="quote-main-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="quote-container">
            <h2>Request a Quote</h2>
            <p>Fill in the details below, and we will get back to you.</p>
            
            {submitted ? (
                <motion.p 
                    className="success-message"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    ✅ Your request has been submitted successfully!
                </motion.p>
            ) : (
                <form className="quote-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Full Name</label>
                        <input 
                            type="text" 
                            id="name" 
                            name="name" 
                            placeholder="Enter your name" 
                            value={formData.name} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input 
                            type="email" 
                            id="email" 
                            name="email" 
                            placeholder="Enter your email" 
                            value={formData.email} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="phone">Phone Number</label>
                        <input 
                            type="tel" 
                            id="phone" 
                            name="phone" 
                            placeholder="Enter your phone number" 
                            value={formData.phone} 
                            onChange={handleChange} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="service">Select Service</label>
                        <select 
                            id="service" 
                            name="service" 
                            value={formData.service} 
                            onChange={handleChange} 
                            required
                        >
                            <option value="">Choose a service</option>
                            <option value="Procurement">Procurement</option>
                            <option value="Engineering">Engineering</option>
                            <option value="Contracting">Contracting</option>
                            <option value="Construction">Construction</option>
                            <option value="Corrosion Control">Corrosion Control</option>
                        </select>
                    </div>

                    <div className="form-group textarea-group">
                        <label htmlFor="details">Additional Information</label>
                        <textarea 
                            id="details" 
                            name="details" 
                            placeholder="Provide any extra details" 
                            value={formData.details} 
                            onChange={handleChange}
                        ></textarea>
                    </div>

                    {error && <p className="error-message">{error}</p>}

                    <div className="button-container">
                        <button type="submit" disabled={loading}>
                            {loading ? 'Sending...' : 'Get Quote'}
                        </button>
                    </div>
                </form>
            )}
        </div>
        <Footer />
      </motion.div>
    );
};

export default RequestQuote;
